export enum Status {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ACTIVE_LOWER = 'active',
  INACTIVE_LOWER = 'inactive',
}

export interface Pagination {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  pageSize: number;
}